import React from 'react'
import {
  Action,
  Actions,
  Detail,
  Details,
  TitleGroup,
  SeeInstallment,
  Price,
  Text,
  Location,
  Division,
  InfoArea,
  Favorite,
} from '@/modern/components/Card'
import MegaFeiraoStamp from '@/modern/components/Stamps/MegaFeirao'
import BlackFeiraoStamp from '@/modern/components/Stamps/BlackFeirao'
import OfertaDestaqueStamp from '@/modern/components/Stamps/OfertaDestaque'
import ParceiroSantanderStamp from '@/modern/components/Stamps/ParceiroSantander'
import AutopagoStamp from '@/modern/components/Stamps/Autopago'
import CarDeliveryExtendedStamp from '@/modern/components/Stamps/ExtendedCarDelivery'
import useFavorites from '@/modern/actions/useFavorites'
import DefineOrderSeals from '@/modern/components/VehicleCardFactory/defineOrderSeals'
import { config } from 'config/config'
import { Link, LinkWithGrow, AlignHeaderStamp } from '../style'

const InfoAreaVertical = ({
  id,
  model,
  make,
  version,
  price,
  year,
  travelledDistance,
  location,
  href = '#',
  hasFavoriteActions = false,
  stamps = {},
  canIUseParceiroSantander,
  wasFavorited = false,
  wasSold = false,
  type,
  oldAd = null,
}) => {
  const { checkIfCardWasFavorited, setFavoriteItem } = useFavorites()
  const linkProps = !wasSold ? { rel: 'nofollow', target: '_blank', href } : {}
  const cardWasFavoritedInStore = checkIfCardWasFavorited(id)
  const { showCarDeliveryExtendedStamp } = config

  return (
    <InfoArea>
      <LinkWithGrow {...linkProps}>
        {stamps.autopago && (
          <AlignHeaderStamp>
            <AutopagoStamp />
          </AlignHeaderStamp>
        )}

        {stamps.feiroes.blackFeirao && (
          <AlignHeaderStamp>
            <BlackFeiraoStamp />
          </AlignHeaderStamp>
        )}

        {stamps.feiroes.megaFeirao && (
          <AlignHeaderStamp>
            <MegaFeiraoStamp />
          </AlignHeaderStamp>
        )}

        {stamps.feiroes.ofertaDestaque && (
          <AlignHeaderStamp>
            <OfertaDestaqueStamp />
          </AlignHeaderStamp>
        )}

        {canIUseParceiroSantander() && (
          <AlignHeaderStamp>
            <ParceiroSantanderStamp />
          </AlignHeaderStamp>
        )}

        {stamps.carDelivery && showCarDeliveryExtendedStamp && (
          <AlignHeaderStamp>
            <CarDeliveryExtendedStamp id={id} />
          </AlignHeaderStamp>
        )}

        <TitleGroup
          needsRightSpace={stamps.superPreco}
          title={`${make} ${model}`}
          subtitle={version}
        />

        <DefineOrderSeals stamps={stamps} />
      </LinkWithGrow>

      <Link {...linkProps}>
        <Price value={price} />
        <Details>
          <Detail>
            <Text value={year} />
          </Detail>
          <Detail>
            <Text value={travelledDistance} />
          </Detail>
        </Details>
        <SeeInstallment link={linkProps.href} />
      </Link>

      <Division />

      <Details minHeight="36px">
        <Detail>
          <Link {...linkProps}>
            <Location value={location} />
          </Link>
        </Detail>
        <Detail grow={false}>
          <Favorite
            id={id}
            onClick={() =>
              setFavoriteItem({
                id,
                type,
                wasFavorited: cardWasFavoritedInStore,
                oldAd,
                details: { ...oldAd, Type: type },
              })
            }
            filled={wasFavorited || cardWasFavoritedInStore}
          />
        </Detail>
      </Details>

      {hasFavoriteActions && (
        <Actions>
          <Action
            onClick={() =>
              setFavoriteItem({
                id,
                type,
                wasFavorited: cardWasFavoritedInStore,
                oldAd,
                details: oldAd,
              })
            }
            value="Remover"
          />
        </Actions>
      )}
    </InfoArea>
  )
}

export default InfoAreaVertical
